// Copyright ©️ 2026 eVolve MEP, LLC

import { type Facility, type Project, useEvolvePaginatedGet } from '@evolvemep/api-ts';
import { ActionIcon, Indicator, Popover, Stack } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { SearchableMultiSelect } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableMultiSelect';

export const WorkOrderFiltersPopover = ({
  projects,
  setProjects,
  facilities,
  setFacilities,
}: {
  projects: Project[];
  setProjects: (v: Project[]) => void;
  facilities: Facility[];
  setFacilities: (v: Facility[]) => void;
}) => {
  const projectsPaginatedGet = useEvolvePaginatedGet('shop/project');
  const facilitiesPaginatedGet = useEvolvePaginatedGet('shop/facility');
  const filterCount = projects.length + facilities.length;

  return (
    <Popover position="bottom-end" withArrow>
      <Popover.Target>
        <Indicator disabled={filterCount === 0} size="lg" label={filterCount}>
          <ActionIcon variant="default" size="input-sm">
            <EvolveIcon icon="FilterAlt" />
          </ActionIcon>
        </Indicator>
      </Popover.Target>
      <Popover.Dropdown w={280}>
        <Stack gap="xs">
          <SearchableMultiSelect
            label="Project"
            paginatedGet={projectsPaginatedGet}
            idKey="projectId"
            getItemLabel={(p) => p.projectName}
            value={projects}
            onChange={setProjects}
            clearable
          />
          <SearchableMultiSelect
            label="Facility"
            paginatedGet={facilitiesPaginatedGet}
            idKey="facilityId"
            getItemLabel={(f) => f.facilityName}
            value={facilities}
            onChange={setFacilities}
            clearable
          />
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
